import _ from "lodash";

export {
    preparePodParentProductsFilters
}

const preparePodParentProductsFilters = (podDetail) => {
    let productTypes = [];
    let categories = [];
    let parentProducts = [];

    _.forEach(podDetail.productTypesList, (productType) => {
        const productTypeDetail = {
            key: productType.name,
            label: productType.label,
            name: productType.name,
        }

        productTypes.push(productTypeDetail);
        prepareCategories(productType, categories, parentProducts);
    });

    return {
        productType: {
            attribute: 'productType',
            options: productTypes,
        },
        category: {
            attribute: 'category',
            options: categories,
        },
        parent: {
            attribute: 'parent',
            options: parentProducts,
        },
    }
}

const prepareCategories = (productType, categories, parentProducts) => {
    _.forEach(productType.categories, (category) => {
        const categoryDetail = {
            key: category.name,
            label: category.name,
            productType: productType.name,
        }

        categories.push(categoryDetail);
        prepareParentProducts(category, productType, parentProducts);
    });
}

const prepareParentProducts = (category, productType, parentProducts) => {
    _.forEach(category.parentProducts, (parentProduct) => {
        const parentProductDetail = {
            product_id: parentProduct.product_id,
            key: parentProduct.name,
            label: parentProduct.name,
            category: category.name,
            productType: productType.name,
        }

        parentProducts.push(parentProductDetail);
    });
}
